import { ExamCenterProctorType, OrderType } from '@exam-center/graphql';
import { type ProctorTypeLabelVariant } from '@exam-center/proctor-management';

import { type DataGridSortDirection } from './types';

export const PROCTOR_TYPE_VARIANT_MAP: Record<ExamCenterProctorType, ProctorTypeLabelVariant> = {
  [ExamCenterProctorType.Proctor_1]: 'proctor-1',
  [ExamCenterProctorType.Proctor_2]: 'proctor-2',
  [ExamCenterProctorType.Proctor_3]: 'proctor-3',
};

export const ORDER_TYPE: Record<DataGridSortDirection, OrderType> = {
  asc: OrderType.Asc,
  desc: OrderType.Desc,
};
